module.exports = __webpack_public_path__ + "static/media/instasm.cfad9cc9.svg";